module.exports = __webpack_public_path__ + "static/img/login-test.3fdce077.png";